import { render, staticRenderFns } from "./item-dialog.vue?vue&type=template&id=1bcf37a2&scoped=true&"
import script from "./item-dialog.vue?vue&type=script&lang=js&"
export * from "./item-dialog.vue?vue&type=script&lang=js&"
import style0 from "./item-dialog.vue?vue&type=style&index=0&id=1bcf37a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf37a2",
  null
  
)

export default component.exports